import { Suspense } from 'react'
import './i18n'
import { Provider as ReduxProvider } from 'react-redux'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { createRoot } from 'react-dom/client'
import { Box, LinearProgress } from '@mui/material'

import { store } from './redux/store'
import App from './App'

import './index.scss'

const container = document.getElementById('root')!
const root = createRoot(container)

root.render(
  <Suspense
    fallback={
      <Box sx={{ width: '100%' }}>
        <LinearProgress />
      </Box>
    }
  >
    <BrowserRouter>
      <ReduxProvider store={store}>
        <Routes>
          <Route path='/*' element={<App />} />
        </Routes>
      </ReduxProvider>
    </BrowserRouter>
  </Suspense>
)
